import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Menuitem } from "../../../../interfaces/Security/menu";
import GenericPromises from "../../../../api/GenericPromises";
import { Button } from "@mui/material";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../../components/Header";
import { ProductServiceKey } from "../../../../interfaces/Sales/Catalogs/productServiceKeys";
import { UpdateProductServiceKeys } from "./update";
import { usePermissions } from "../../../../hooks/usePermissions";
import { GenericDialog } from "../../../../components/Dialogs/Dialog";
import { ButtonStyled } from "../../../../theme/buttons";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";

export const ViewProductServiceKeys = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const [productServiceKeyLocal, setProductServiceKeyLocal] = useState<ProductServiceKey>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();
  const {showSnackBar,SnackbarComponent}= useSnackBar();


  const onDelete = () => {
    GenericDeleteResource(`/productservicekeys/${productServiceKeyLocal?.product_service_key_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/productservicekeys", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message,'error');
        setOpenDialog(false);
      })
  }


  useEffect(() => {
    if (location.state === null) return navigate("/productservicekeys", { state: {}, replace: true });
    GenericGetResource(`/productservicekeys/${location.state.row.product_service_key_id}`)
      .then(
        (response) => {
          setProductServiceKeyLocal(response.data);

          GetResourceByUrl(`/productservicekeys`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message,'error');
            });
        }
      ).catch((error) => {
        showSnackBar(error.message,'error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <>
          <Header
            title={t("productservicekeys.title-view")}
            child={
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" onClick={() => { navigate("/productservicekeys", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />
          {resourceScreen?.read &&
            <>
              <div>
                <UpdateProductServiceKeys productServiceKeysPayload={productServiceKeyLocal} isEdit={resourceScreen?.update} />
              </div>
            </>
          }
        </>
      }
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("productservicekeys.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent/>
    </>
  )
}